module.exports = __webpack_public_path__ + "img/Super50.dee61517.png";